export function brandNameLoadJson() {
  if (document.querySelector('.c-data-area__name')) {
    const jsonUrl = '/assets/json/brandNameList.json';
    fetch(jsonUrl)
      .then((data) => data.json())
      .then(function (json) {
        const itemListValue = Object.keys(json);
        for (const property of itemListValue) {
          const targetId = 'brand' + json[property].id;
          const contentArea = document.querySelector('.c-data-area__name');
          const article = document.createElement('article');
          const divHeader = document.createElement('div');
          const title = document.createElement('h2');
          const itemTitle = document.createElement('h3');
          const item = document.createElement('p');
          const url = document.createElement('button');
          title.innerText = json[targetId].title;
          itemTitle.innerText = '主な商品';
          item.innerText = json[targetId].item;
          url.innerHTML =
            '<a href="' + json[targetId].url + '" class="external" target="_blank">公式サイト</a>';
          article.id = targetId;
          article.className = 'c-data-area__article c-button__data-modal';
          divHeader.className = 'item-header';
          title.className = 'item-title';
          item.className = 'item-item';
          article.appendChild(divHeader);
          article.appendChild(title);
          article.appendChild(itemTitle);
          article.appendChild(item);
          if (json[targetId].url.length) {
            article.appendChild(url);
          }
          contentArea.appendChild(article);
        }
      });
  }
}
